import Vue from "vue";

export class ReservaTecnica {
    static create() {
        return {
            nome: null,
            place: [0, 0],
            obs: null
        };
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byID(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("reserva-tecnica/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static excluir(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .delete("reserva-tecnica/" + id)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static all() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("reservas-tecnicas")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static save(data) {
        return new Promise((resolve, reject) => {
            let promisse = null;

            if (data._id) {
                promisse = Vue.http.put("reserva-tecnica/" + data._id, data);
            } else {
                promisse = Vue.http.post("reserva-tecnica/0", data);
            }

            promisse.then(() => resolve(), err => reject(err));
        });
    }
}
